module.exports = __webpack_public_path__ + "img/yf.cd827469.svg";